import { FIAT_ORDER, FiatOrderSet } from '@exodus/models'
import { ORDER_TYPES } from '@exodus/fiat-client'
import { createSelector } from 'reselect'

const selectorFactory = (assetsSelector, orderDataSelector) =>
  createSelector(assetsSelector, orderDataSelector, (assets, fiatOrders) =>
    FiatOrderSet.fromArray(
      [...fiatOrders].filter(
        (order) =>
          FIAT_ORDER.ORDER_STATUS.initiated !== order.exodusStatus &&
          Object.values(FIAT_ORDER.ORDER_STATUS).includes(order.exodusStatus) &&
          (order.orderType === ORDER_TYPES.buy ? assets[order.toAsset] : assets[order.fromAsset])
      )
    )
  )

const visibleOrdersSelectorDefinition = {
  id: 'visibleOrders',
  selectorFactory,
  dependencies: [{ module: 'assets', selector: 'all' }, { selector: 'orderData' }],
}

export default visibleOrdersSelectorDefinition
